module.exports = __webpack_public_path__ + "img/user_not_activated.24bfb028.svg";